import React from "react";
import { useLang } from "../../i18n/LanguageContext";

export default function Steps() {
  const { t } = useLang();
  return (
    <section className="relative pt-14 pb-24 md:py-32 bg-[var(--aa-cream-warm)]">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <div className="reveal max-w-3xl">
          <div className="text-[11px] tracking-[0.24em] uppercase text-[var(--aa-wine)] font-semibold mb-4">
            {t.steps.eyebrow}
          </div>
          <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.05] text-[var(--aa-ink)]">
            {t.steps.h2a} <span className="italic">{t.steps.h2b}</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5 md:gap-6 relative">
          <div className="hidden md:block absolute top-10 left-[16%] right-[16%] h-px bg-[var(--aa-line)]"></div>

          {t.steps.items.map((s, i) => (
            <div
              key={i}
              className="reveal lift relative rounded-3xl bg-white border border-[var(--aa-line)] p-8"
            >
              <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-full bg-[var(--aa-wine)] text-[var(--aa-cream)]">
                <span className="font-display text-3xl italic">{s.n}</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl mt-6 text-[var(--aa-ink)]">
                {s.title}
              </h3>
              <p className="mt-3 text-[14.5px] text-[var(--aa-ink-soft)] leading-relaxed">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
